const fetchEpisodes = async (filters) => {
  const filtersString = JSON.stringify(filters);
  const episodes = await fetch(innovantsData.ajax, {
    method: "POST",
    body: new URLSearchParams({
      action: "innovants_load_episodes",
      filters: filtersString,
    }),
  });
  return await episodes.json();
};

export default fetchEpisodes;
